import axios from "axios";

export const updateAppStateApi = <T>(data: { slice_key: string; state: T }) => {
    return axios.patch(route("state.update"), data);
};
